var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "player-container" }, [
    _c("div", { staticClass: "content" }, [
      _c("p", [_vm._v("姓名：" + _vm._s(_vm.player.name))]),
      _vm._v(" "),
      _c("p", [_vm._v("电话：" + _vm._s(_vm.player.phone))]),
      _vm._v(" "),
      _c("p", [_vm._v("性别：" + _vm._s(_vm.player.gender))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d43ca786", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d43ca786","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/player-info/index.vue
// module id = null
// module chunks = 